import { api } from '../services/api.js';

const API_URL = '/api/events/';
function useAnalytics() {
    const capture = async (analyticsEvent, token) => {
        const headers = { Authorization: `Bearer ${token}` };
        const { analyticsData, ...event } = analyticsEvent;
        return api.post(API_URL, {
            locationId: analyticsData.locationId,
            subLocationId: analyticsData.subLocationId,
            ...event,
        }, { headers });
    };
    return { capture };
}

export { useAnalytics as default };
